import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, registerables } from 'chart.js';

ChartJS.register(...registerables);

// Custom plugin to display percentage
const percentagePlugin = {
    id: 'percentagePlugin',
    afterDraw: (chart) => {
        const { ctx, chartArea, data } = chart;
        const totalValue = data.datasets[0].data.reduce((a, b) => a + b, 0);
        const percentage = totalValue ? ((data.datasets[0].data[0] / totalValue) * 100).toFixed(0) : 0;

        ctx.save();
        ctx.font = 'bold 20px Arial';
        ctx.fillStyle = '#000';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(`${percentage}%`, chartArea.left + (chartArea.right - chartArea.left) / 2, chartArea.top + (chartArea.bottom - chartArea.top) / 2);
        ctx.restore();
    },
};

ChartJS.register(percentagePlugin);

const CommentAnalysis = () => {
    const intentToBuyData = {
        labels: ['Intent to Buy', 'No Intent'],
        datasets: [{
            data: [0, 15],
            backgroundColor: ['#04DB8E', '#E5E5E8'],
            borderWidth: 2,
            hoverBackgroundColor: ['#03C77A', '#D1D1D1'],
        }],
    };

    const audienceSentimentData = {
        labels: ['Positive', 'Neutral', 'Negative'],
        datasets: [{
            data: [13, 2, 2],
            backgroundColor: ['#04DB8E', '#E5E5E8', '#D91D4A'],
            borderWidth: 2,
            hoverBackgroundColor: ['#03C77A', '#D1D1D1', '#C71D4A'],
        }],
    };

    const options = {
        cutout: '85%',
        plugins: {
            legend: {
                display: true,
                position: 'right',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    boxWidth: 20,
                },
            },
            percentagePlugin: {},
        },
    };

    const renderDoughnutChart = (data, title, subtitle) => (
        <Col>
            <div className="MuiBox-root">
                <div className="div-cell">
                    <div className="recharts-wrapper" role="region" style={{ position: 'relative', cursor: 'default', width: '200px', height: '200px' }}>
                        <Doughnut data={data} options={options} />
                    </div>
                </div>
                <div className="div-cell">
                    <div className="sub-section-heading">{title}</div>
                    <div className="body-r subtitle comments-message w-75">{subtitle}</div>
                </div>
            </div>
        </Col>
    );

    return (
        <Card id="comment-analysis" className="my-3 mx-4">
            <Card.Body>
                <section className="profile-discovery-comment-analysis-container">
                    <div className="div-comments-analysis">
                        <div className="div-comments-analysis-header d-flex justify-content-between align-items-center">
                            <div className="div-left-header">
                                <div className="section-heading h5">Comments analysis</div>
                                <p className="body-r subtitle">We analyzed 15 comments across the most relevant posts by this creator. Last updated Nov 27, 2024</p>
                            </div>
                        </div>
                        <div className="div-comments-analysis-content">
                            <Row className="div-row div-first-row" style={{ gap: '60px' }}>
                                {renderDoughnutChart(intentToBuyData, 'Intent to buy product', '0/15 comments\nComments in which people have shown intent to buy the product/service.')}
                                {renderDoughnutChart(audienceSentimentData, 'Audience sentiment', 'Comments classified on the basis of the opinions and emotions behind them.')}
                            </Row>
                        </div>
                    </div>
                </section>
            </Card.Body>
        </Card>
    );
};

export default CommentAnalysis;
